module.exports = __webpack_public_path__ + "img/et-700.0e274c31.webp";